import { useState, type KeyboardEvent } from 'react';
import { Box, Input, Tag, TagLabel, TagCloseButton, Wrap, WrapItem } from '@chakra-ui/react';

interface TagsInputProps {
  value: string[];
  onChange: (tags: string[]) => void;
  placeholder?: string;
  max?: number;
}

/** Chip-style tag editor: type + Enter/comma to add, click ✕ to remove. */
export function TagsInput({ value, onChange, placeholder, max = 20 }: TagsInputProps) {
  const [input, setInput] = useState('');

  const add = (raw: string) => {
    const tag = raw.trim();
    setInput('');
    if (!tag || value.includes(tag) || value.length >= max) return;
    onChange([...value, tag]);
  };

  const onKeyDown = (e: KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter' || e.key === ',') {
      e.preventDefault();
      add(input);
    } else if (e.key === 'Backspace' && !input && value.length) {
      onChange(value.slice(0, -1));
    }
  };

  return (
    <Box>
      {value.length > 0 && (
        <Wrap mb={2} spacing={2}>
          {value.map((tag) => (
            <WrapItem key={tag}>
              <Tag colorScheme="brand" borderRadius="full">
                <TagLabel>{tag}</TagLabel>
                <TagCloseButton onClick={() => onChange(value.filter((t) => t !== tag))} />
              </Tag>
            </WrapItem>
          ))}
        </Wrap>
      )}
      <Input
        value={input}
        placeholder={placeholder}
        onChange={(e) => setInput(e.target.value)}
        onKeyDown={onKeyDown}
        onBlur={() => add(input)}
      />
    </Box>
  );
}

export default TagsInput;
